import request from "../../untils/request.js"


//分页
export const getPayOrder = (params) => {
    return request.get('/outpatient/payorder/page',{params})
}

//退款
export const orderRefund = (params) => {
    return request.get('/outpatient/sqb/refund',{params})
}


export default{
}

